import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.299 4.488a1.5 1.5 0 0 0-2.599 0L3.346 17.236a1.5 1.5 0 0 0 1.299 2.25h14.709a1.5 1.5 0 0 0 1.299-2.25zm-3.898-.75c1.155-2.001 4.043-2.001 5.197 0l7.354 12.747c1.154 2-.29 4.499-2.599 4.499H4.645c-2.309 0-3.752-2.499-2.599-4.499L9.401 3.739zM12 7.985a.75.75 0 0 1 .75.75v5.416a.75.75 0 1 1-1.5 0V8.735a.75.75 0 0 1 .75-.75m-.75 9.166a.75.75 0 0 1 .75-.75h.007a.75.75 0 0 1 .75.75v.007a.75.75 0 0 1-1.284.527.75.75 0 0 1-.223-.534"
}));
const ForwardRef = forwardRef(SvgComponent);
export const ExclamationTriangleIcon = ForwardRef;